<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar
                :isCustomReturnEvent="true"
                :isTitleNormal="true"
                :isAllFunctions="true"
                title="返回"
                @returnEvent="handleClickClose"
            ></ReturnNavBar>
        </div>
        <div class="work_order_add_container mobile_container custom_mobile_form" v-loading="loading">
            <van-form
                label-width="9.5em"
                input-align="right"
                scroll-to-error
                :show-error-message="false"
                :rules="workOrderFeedBackFormRules"
                ref="workOrderFeedBackForm"
                class=""
            >
                <van-field
                    :required="true"
                    v-model="workOrderFeedBackForm.work_date"
                    :name="'work_date'"
                    label="日期"
                    placeholder="请选择"
                    :rules="workOrderFeedBackFormRules.work_date"
                    error-message-align="right"
                    is-link
                    readonly
                    @click="handleClickDateFieldlink"
                >
                </van-field>
                <van-field
                    :required="is_clock"
                    v-model="selectClockInRecordData.dateTxt"
                    :name="'clock_id'"
                    label="管理打卡记录"
                    placeholder="请选择打卡记录"
                    :rules="rules"
                    error-message-align="right"
                    is-link
                    readonly
                    @click="handleChangeClockRecord"
                    class="custom_clock_field"
                >
                </van-field>
                <div class="clock_in_form_item">
                    <span @click="handleclickClockIn">
                        <i class="iconfont icon-weizhi1"></i>
                        <span>去打卡</span>
                    </span>
                </div>
                <van-field
                    :required="true"
                    v-model="workOrderFeedBackForm.work_content"
                    name="work_content"
                    label="工作内容"
                    placeholder="请输入"
                    :rules="workOrderFeedBackFormRules.work_content"
                    error-message-align="right"
                    type="textarea"
                    :rows="5"
                    maxlength="500"
                    input-align="left"
                    class="vertical_input_wrap"
                >
                </van-field>
                <div class="file_img_outer_wrap">
                    <div class="image_outer_wrap">
                        <ul class="upload_image_list">
                            <li v-for="item in imageList" :key="item.file_path" class="upload_image_item">
                                <el-image
                                    :preview-src-list="imageList.map((img) => img.file_path)"
                                    :src="item.file_path"
                                    fit="cover"
                                >
                                </el-image>
                                <i class="el-icon-error" @click="imageList.splice(index, 1)"></i>
                            </li>
                        </ul>
                    </div>
                    <div class="commentFiles">
                        <ul>
                            <li v-for="(file, fileIndex) in fileList" :key="fileIndex">
                                <p class="ellipsis" v-text="file.file_name"></p>
                                <div>
                                    <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                        <i class="iconfont icon-yanjing"></i>
                                    </span>
                                    <span class="handle_icon_wrap" @click="handleClickDelFile(fileIndex)">
                                        <i class="iconfont icon-shanchu1"></i>
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="commentHandle">
                        <div>
                            <span class="handle_icon_wrap" @click="handleClickCommentUpload('file')">
                                <i class="iconfont icon-lianjie"></i>上传附件
                            </span>
                            <span class="handle_icon_wrap" @click="handleClickCommentUpload('image')">
                                <i class="iconfont icon-tupian"></i>上传图片
                            </span>
                        </div>
                    </div>
                </div>
            </van-form>
        </div>
        <div class="add_footer_wrap mobile_add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>
        <!--_年_月_日 日期选择-->
        <van-calendar
            v-model="showDateCalendar"
            color="#2990FF"
            :min-date="dateCalendarMin"
            :max-date="dateCalendarMax"
            @confirm="handleDateCalenderConfirm"
        />
        <!-- 选择打卡记录 -->
        <ClockRecordSelect
            :selectClockRecordPopupShow.sync="selectClockRecordPopupShow"
            v-if="selectClockRecordPopupShow"
            :selectData="selectData"
            @success="selectClockRecordSuccess"
        />
        <el-image ref="preview_img" :preview-src-list="previewImgList" :src="previewImgSrc" style="display: none">
        </el-image>
        <ClockInComponent
            v-if="clockInPopupShow"
            :clockInPopupShow.sync="clockInPopupShow"
        />
    </div>
</template>
<script>
import { workOrderSetDetail, workOrderFeedBack } from "@/api";
import { uploadImg, getOSSData } from "@/utils/uploadOss";
import { formatFileSize, getNowDate, formatDate } from "@/utils";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import ClockRecordSelect from "./clock_record_select.vue";
import ClockInComponent from "@/components/mComponents/clockInComponent.vue";
import {EventBus} from '@/utils/eventBus';
export default {
    name: "WorkOrderFeedBack",
    components: { ReturnNavBar, ClockRecordSelect , ClockInComponent},
    data() {
        return {
            loading: false,
            workorder_id: this.$route.query.id,
            workOrderFeedBackForm: {
                work_date: getNowDate(),
                work_content: "",

                clock_id: "",
            },
            workOrderFeedBackFormRules: {
                work_date: [{ required: true, message: "请选择日期", trigger: "change" }],
                work_content: [{ required: true, message: "请输入", trigger: "blur" }],
            },
            imageList: [],
            fileList: [],

            selectClockRecordPopupShow: false,
            selectClockInRecordData: {}, // 选择的数据
            selectData: [],

            is_clock: false, // 是否需现场打卡证明

            previewImgList: [],
            previewImgSrc: "",

            showDateCalendar: false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date("2070-01-01"),

            btnDisabled: false,
            clockInPopupShow: false,
        };
    },
    computed: {
        rules() {
            if (this.is_clock) {
                return [
                    {
                        required: true,
                        message: "请选择打卡记录",
                        trigger: ["blur", "change"],
                    },
                ];
            }
            return [];
        },
    },
    created() {
        this.getWorkOrderSetDetail();
    },
    methods: {
        handleClickClose() {
            this.$router.go(-1);
        },
        // 获取是否需现场打卡证明
        getWorkOrderSetDetail() {
            this.loading = true;
            workOrderSetDetail()
                .then((res) => {
                    this.is_clock = res.data.is_clock == 1 ? true : false;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 选择日期
        handleClickDateFieldlink() {
            this.showDateCalendar = true;
        },
        //点击日期选择器确定事件
        handleDateCalenderConfirm(date) {
            this.workOrderFeedBackForm.work_date = formatDate(date, "date");
            this.showDateCalendar = false;
        },
        // 去打卡
        handleclickClockIn() {
            this.clockInPopupShow = true;
        },
        // 选择关联打卡记录
        handleChangeClockRecord() {
            this.selectClockRecordPopupShow = true;
        },
        // 选择打卡记录成功
        selectClockRecordSuccess(data) {
            this.selectData = data;
            let selectClockInRecordData = data && data.length ? data[0] : {};
            selectClockInRecordData.dateTxt =
                selectClockInRecordData.punch_type == "SINGLE"
                    ? selectClockInRecordData.created_at
                    : selectClockInRecordData.start_time + "~" + (selectClockInRecordData.end_time || "");
            this.selectClockInRecordData = selectClockInRecordData;
        },
        handleClickCommentUpload(type) {
            let that = this;
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            // input.setAttribute('multiple', 'multiple')
            if (type == "image") {
                input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
            } else {
                input.setAttribute("accept", "");
            }
            input.click();
            input.onchange = function () {
                const file = this.files[0];
                if (type == "image" && file.type.indexOf("image") < 0) {
                    that.$toast("请上传图片文件！");
                    return false;
                }
                that.loading = true;
                if (file) {
                    uploadImg(file)
                        .then((res) => {
                            if (res.file_path) {
                                if (type == "image") {
                                    that.imageList.push({ file_name: res.file_name, file_path: res.file_path });
                                } else {
                                    res.file_size = formatFileSize(file.size);
                                    that.fileList.push(res);
                                }
                            }
                            that.loading = false;
                        })
                        .catch(() => {
                            that.loading = false;
                        });
                }
            };
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$toast("当前文件类型不支持预览");
                }
            }
        },
        handleClickDelFile(key) {
            this.fileList.splice(key, 1);
        },
        handleClickConfirm() {
            this.$refs.workOrderFeedBackForm.validate().then(() => {
                const params = {
                    workorder_id: this.workorder_id,
                    work_date: this.workOrderFeedBackForm.work_date,
                    work_content: this.workOrderFeedBackForm.work_content,
                    clock_id: (this.selectClockInRecordData && this.selectClockInRecordData.id) || 0,
                    files: this.imageList.concat(this.fileList),
                };
                this.btnDisabled = true;
                workOrderFeedBack(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    EventBus.$emit('workOrderAddUpdated');
                                    this.$router.go(-1);
                                    this.btnDisabled = false;
                                },
                            });
                        } else {
                            this.btnDisabled = false;
                        }
                    })
                    .catch(() => {
                        this.btnDisabled = false;
                    });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.mobile_container {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    .vertical_input_wrap {
        &::after {
            display: none;
        }
    }
    .file_img_outer_wrap {
        background-color: #ffffff;
        padding: 12px 16px;
    }
    .image_outer_wrap {
        .image_upload_wrap {
            width: 32px;
            height: 32px;
            opacity: 1;
            border-radius: 4px;
            background: #edf0f4;
            text-align: center;
            line-height: 32px;
            margin-bottom: 2px;
            cursor: pointer;
            position: relative;

            .upload_input {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                opacity: 0;
                cursor: pointer;
            }
        }

        .upload_image_list {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .upload_image_item {
                width: 32px;
                height: 32px;
                opacity: 1;
                border-radius: 4px;
                text-align: center;
                line-height: 32px;
                position: relative;
                margin-bottom: 8px;

                .el-image {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                }

                .el-icon-error {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    color: #999999;
                    font-size: 16px;
                    cursor: pointer;
                }
            }
        }

        .image_hint {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: #999999;
        }
    }
    .commentFiles {
        width: 100%;
        ul {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            min-height: 26px;
            padding-bottom: 10px;
            li {
                width: 100%;
                margin-bottom: 4px;
                border-radius: 2px;
                background: rgba(249, 249, 249, 1);
                border: 1px solid rgba(217, 217, 217, 1);
                line-height: 20px;
                height: 22px;
                padding: 0 8px;
                box-sizing: border-box;
                position: relative;
                display: flex;
                justify-content: space-between;
                align-items: center;
                p {
                    font-size: 12px;
                    color: rgba(102, 102, 102, 1);
                    width: calc(100% - 50px);
                }
                div {
                    width: 40px;
                    display: flex;
                    justify-content: space-between;
                    span.handle_icon_wrap {
                        width: 16px;
                        height: 16px;
                        font-size: 12px;
                        line-height: 16px;
                        i {
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }
    .commentHandle {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .handle_icon_wrap {
            font-size: 14px;
            width: auto;
            color: rgba(102, 102, 102, 100);
            i {
                margin-right: 4px;
            }
        }
        span + span {
            margin-left: 16px;
        }
        .word_count {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(153, 153, 153, 1);
        }
    }
    .custom_clock_field {
        &::after {
            display: none;
        }
    }
    .clock_in_form_item {
        padding: 2px 0 10px;
        background-color: #ffffff;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        text-align: center;
        line-height: 22px;
        color: rgba(25, 144, 255, 1);
        position: relative;
        .iconfont {
            margin-right: 4px;
        }
        &::after {
            position: absolute;
            box-sizing: border-box;
            content: ' ';
            pointer-events: none;
            right: 0;
            bottom: 0;
            left: 0;
            border-bottom: 1px solid #ebedf0;
            -webkit-transform: scaleY(.5);
            transform: scaleY(.5)
        }
    }
}
</style>
